import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import styled from "styled-components";
import { deleteShipment, setShipmentActionData } from "../../../features/loadList/loadListSlice";
import { showModal } from "../../../features/modal/modalSlice";
import { useScrollLock } from "../../../hooks/useScrollLock";
import Btn from "../../shared/button/Btn";
import SmallSpinner from "../../shared/spinners/SmallSpinner";

const Container = styled.div`
  position: fixed;
  inset: 0;
  z-index: 100;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 20px;
  background: rgba(0, 0, 0, .6);

  .modal { width: min(520px, 100%); padding: 30px; border-radius: 12px; background: ${({theme}) => theme.mainBgColor}; color: ${({theme}) => theme.mainTextColor}; }
  h2 { margin: 0 0 12px; font-size: var(--font-size-md); }
  p { margin: 0 0 12px; line-height: 1.5; }
  .warning { color: #E85446; font-size: var(--font-size-sm); }
  .actions { display: flex; justify-content: flex-end; gap: 12px; margin-top: 26px; }
  @media (max-width: 520px) { .actions { flex-direction: column-reverse; } .actions button { width: 100%; } }
`;

const DeleteShipmentPermissionModal = () => {
  const dispatch = useDispatch();
  const {lockScroll, unlockScroll} = useScrollLock();
  const {shipmentActionData, isLoadingDeleteShipment} = useSelector(state => state.loadList);

  useEffect(() => {
    lockScroll();
    return () => unlockScroll();
  }, [lockScroll, unlockScroll]);

  const close = () => {
    if (isLoadingDeleteShipment) return;
    dispatch(showModal(null));
    dispatch(setShipmentActionData(null));
  };

  return (
    <Container onClick={close}>
      <div className="modal" onClick={(event) => event.stopPropagation()}>
        <h2>Sevkiyatı Sil</h2>
        <p>Sevkiyat ID: {shipmentActionData?.id ?? "---"}</p>
        <p className="warning">Bu işlem sevkiyata bağlı rota, belge, konum ve takip kayıtlarını kalıcı olarak siler ve geri alınamaz.</p>
        <div className="actions">
          <Btn width="130px" color="#E85446" bgColor="transparent" handleClick={close} isDisabled={isLoadingDeleteShipment}>Vazgeç</Btn>
          <Btn width="170px" color="#fff" bgColor="#E85446" borderColor="transparent" handleClick={() => dispatch(deleteShipment(shipmentActionData?.id))} isDisabled={!shipmentActionData?.id || isLoadingDeleteShipment}>
            {isLoadingDeleteShipment ? <SmallSpinner size="20px" color="#fff" bgColor="#E85446" /> : "Kalıcı Olarak Sil"}
          </Btn>
        </div>
      </div>
    </Container>
  );
};

export default DeleteShipmentPermissionModal;
